import { render, staticRenderFns } from "./BlocksTransactionsRowSkeleton.vue?vue&type=template&id=54c3dcaa&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports